// skeleton/app/src/app/shared/services/token-storage.service.ts

import { Injectable } from '@angular/core';

const TOKEN_KEY = 'auth_token';
const REFRESHTOKEN_KEY = 'refresh_token';
const USER_KEY = 'auth-user';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  set(key: string, value: string): void {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      console.error(`Error setting sessionStorage key "${key}":`, error);
    }
  }

  get(key: string): string | null {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      console.error(`Error getting sessionStorage key "${key}":`, error);
      return null;
    }
  }

  remove(key: string): void {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing sessionStorage key "${key}":`, error);
    }
  }

  clear(): void {
    window.sessionStorage.clear();
  }

  has(key: string): boolean {
    return window.sessionStorage.getItem(key) !== null;
  }

  signOut(): void {
    window.sessionStorage.clear();
  }

  public saveToken(token: string): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);

    const user = this.getUser();
    if (user && user.id) {
      this.saveUser({ ...user, accessToken: token });
    }
  }

  public getToken(): string | null {
    return window.sessionStorage.getItem(TOKEN_KEY);
  }

  public saveRefreshToken(token: string): void {
    window.sessionStorage.removeItem(REFRESHTOKEN_KEY);
    window.sessionStorage.setItem(REFRESHTOKEN_KEY, token);
  }

  public getRefreshToken(): string | null {
    return window.sessionStorage.getItem(REFRESHTOKEN_KEY);
  }

  public saveUser(user: any): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    const user = window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }
}

/**
 * Backwards compatibility alias:
 * Older files import { StorageService } from '.../token-storage.service'
 * Newer code should use TokenStorageService.
 */
export { TokenStorageService as StorageService };
